"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Buttons_1 = require("../Buttons");
var BlockLabel_1 = require("../../v2/components/BlockLabel");
var getBlockLabelProps_1 = require("../../utils/getBlockLabelProps");
var bannerContext_1 = require("../Banners/bannerContext");
var styled_components_1 = require("styled-components");
var useFakeUploadImpression_1 = require("../../utilsOolib/useFakeUploadImpression");
var AudioAction_1 = require("./comps/AudioAction");
var AudioPlayer_1 = require("./comps/AudioPlayer");
var styled_js_1 = require("./styled.js");
var FileUploadWrapper_1 = require("../FileUploadWrapper");
function AudioInput(_a) {
    var id = _a.id, value = _a.value, parentOnChange = _a.onChange, readOnly = _a.readOnly, invert = _a.invert, isInRTE = _a.isInRTE, files = _a.files, props = __rest(_a, ["id", "value", "onChange", "readOnly", "invert", "isInRTE", "files"]);
    var audioData = value || [];
    var theme = (0, styled_components_1.useTheme)();
    var _b = (0, react_1.useState)(null), uploadProgress = _b[0], setUploadProgress = _b[1];
    var SET_ALERT_BANNER = (0, bannerContext_1.useBannerContext)().SET_ALERT_BANNER;
    var handleUploadProgess = function (progress) { return setUploadProgress(progress); };
    var inputRef = (0, react_1.useRef)();
    var _c = (theme === null || theme === void 0 ? void 0 : theme.useUploadMedia({
        mediaConfigs: {
            type: "files",
            folderName: "audios",
            mediaType: "audio",
        },
        handleUploadProgess: handleUploadProgess,
    })) || (0, useFakeUploadImpression_1.useFakeUploadImpression)({ handleUploadProgess: handleUploadProgess, fileType: "audio" }), upload = _c.mutate, isLoading = _c.isLoading;
    var handleUpload = function (_a) {
        var files = _a.files;
        if (!files)
            return;
        if (!upload)
            return;
        upload(files, {
            onSuccess: function (data) {
                parentOnChange(id, [data[0].fileData]);
            },
            onError: function (err) {
                var _a;
                SET_ALERT_BANNER(((_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors[0].msg) || err.message, "red", 3500);
            },
        });
    };
    (0, react_1.useEffect)(function () {
        if (files) {
            handleUpload({ files: files });
        }
    }, []);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        readOnly ? (react_1.default.createElement(AudioPlayer_1.AudioPlayer, { audioData: audioData })) : (audioData === null || audioData === void 0 ? void 0 : audioData.length) === 0 ? (react_1.default.createElement(FileUploadWrapper_1.FileUploadWrapper, { height: '18rem', isLoading: isLoading, uploadProgress: uploadProgress, mediaType: 'audio', enableClickUpload: false, handleUpload: handleUpload },
            react_1.default.createElement(Buttons_1.ButtonSecondary, { onClick: function () { return inputRef.current.click(); }, icon: "UploadSimple", value: "Upload Audio", accept: "audio/*", invert: invert }))) : (audioData && (react_1.default.createElement(styled_js_1.StyledAudioPlayerWrapper, { isInRTE: isInRTE },
            react_1.default.createElement(AudioPlayer_1.AudioPlayer, { audioData: audioData }),
            react_1.default.createElement(AudioAction_1.AudioAction, { id: id, isInRTE: isInRTE, inputRef: inputRef, parentOnChange: parentOnChange })))),
        react_1.default.createElement("input", { type: "file" // When user clicks on upload new video from action menu inputRef.current.click() this does not work for upload button. this approch deals with that issue.
            , accept: "audio/*", ref: inputRef, style: { display: "none" }, id: "AudioField", onChange: function (v) {
                handleUpload({ files: v.target.files });
            } })));
}
;
exports.default = AudioInput;
